<template>
  <div class="nav">
    <div class="nav-header" @mouseover="openDrop = true">
      <div class="nav-header-title">
        <slot name="title" />
        <i
          v-if="hasArrow"
          class="el-icon-arrow-down nav-header-title_icon-arrow"
        ></i>
      </div>
    </div>
    <div class="nav-body" :class="{ 'is-custom': isCustom }">
      <div class="sg-menu" :class="classObj">
        <slot name="body">
          <ul class="sg-menu-ul">
            <slot />
          </ul>
        </slot>
      </div>
      <!-- <slot name="body">
        <ul class="sg-menu">
          <slot />
        </ul>
      </slot> -->
    </div>
  </div>
</template>
<script>
export default {
  props: {
    hasArrow: {
      type: Boolean,
      default: true,
    },
    isCustom: {
      type: Boolean,
      default: false,
    }
   
  },
  computed: {
    classObj() {
      return {
        "close-class": !this.openDrop,
      };
    },
    // styleObject() {
    //   return {
    //     height: this.isOpen ? "auto" : 0,
    //     opcity: this.isOpen ? 1 : 0,
    //   };
    // },
  },
  data() {
    return {
      openDrop: false,
      // isClose: false,
    };
  },
  created() {
    // this.$on("toggle", function (args) {
    //   this.openDrop = false;
    //   this.$emit("select", args);
    // });
    this.$on("select", function (args) {
      this.openDrop = false;
      // this.$emit("select", args);
    });
    // window.addEventListener("click", function () {
    //   debugger
    //   this.isClose=false
    // });
  },
  // mounted() {
  //   document.addEventListener("click", function () {
  //     this.isClose = false;
  //   });
  // },
  method() {},
};
</script>
<style lang="scss" scoped>
// .nav.is-open {
//   // .nav-header > .nav-header-title .nav-header-title_icon-arrow {
//   //   transform: rotateZ(180deg);
//   // }
//   .sg-menu {
//     height: auto;
//   }
// }
.nav {
  cursor: pointer;
  // text-align: center;
  position: relative;

  //   &.is-open {
  &:hover {
    // transition-delay: 5s;
    .nav-header,
    .sg-menu {
      border: solid 1px #e6e6e6;
    }
    .nav-header {
      position: relative;
      border-bottom: none;
      background-color: #fff;
      border-bottom: none;
      color: #ff4f1a;
      & > .nav-header-title .nav-header-title_icon-arrow {
        transform: rotateZ(180deg);
      }
      &::after {
        position: absolute;
        content: "";
        bottom: -1px;
        width: 100%;
        left: 0;
        height: 2px;
        background-color: #fff;
        //  background-color: red;
        z-index: 9999999;
      }
    }
    .nav-body {
      &.is-custom {
        .sg-menu {
          
          border-top: 1px solid #e6e6e6;
          // border-top: 1px solid red;
          // background-color: red;

          // width: max-content;
          min-width: 100%;
          padding: 5px 10px;
        }
      }
      .sg-menu {
        border-top: none;
        height: auto;
        //  height: 300px;
        opacity: 1;

        // display: block;
        // text-align: left;
        //   .sg-menu-item {
        //     &:hover {
        //       background-color: #f2f4f5;
        //     }
        //   }
      }
      .close-class {
        opacity: 0;
        height: 0;
      }
    }
  }
  .nav-header-title_icon-arrow {
    margin-left: 4px;
    font-size: 12px;
  }

  //   &:hover{
  //      .nav-header > .nav-header-title .nav-header-title_icon-arrow {
  //       transform: rotateZ(180deg);
  //     }
  //     .sg-menu{
  //         height: auto;
  //     }
  //   }
  .nav-body {
    &::after {
      content: "";
      display: block;
      line-height: 0;
      clear: both;
    }
    &.is-custom {
      .sg-menu {
        width: auto;//真的

        // border-top: 1px solid #e6e6e6;
        // // width: max-content;
        // min-width: 100%;
        // padding: 5px 10px;
      }
    }
    .sg-menu {
      list-style: none;
      // position: relative;
      margin: 0;
      background-color: #ffffff;
      padding: 0;
      z-index: 100;
      position: absolute;
      // top: 36px;
      // float: left;
      height: 0;
      opacity: 0;
      // display: none;
      width: 100%;
      overflow: hidden;
      // transition: all 10s;
      transition: opacity 0.5s;
      float: left;
    }
    .sg-menu .sg-menu-ul {
      margin: 0;
      padding: 0;
    }
  }
  .nav-header {
    border: 1px solid transparent;
  }
  //   .nav-header-title,
  //   .sg-menu-item {
  //     padding: 5px 10px;
  //     line-height: 24px;
  //   }
  .nav-header-title {
    padding: 5px 10px;
    line-height: 24px;
    display: flex;
    align-items: center;
  }

  // .fullWidth {
  //   width: 100% !important;
  // }
  .border-top {
    border: solid 1px #e6e6e6;
  }
  a {
    text-decoration: none;
  }
}
</style>
